import React, { FC, ReactNode, useEffect, useState } from 'react';
import { animated, useSpring } from 'react-spring';
import { useMeasure } from 'react-use';
import styled from 'styled-components';

import theme from '@theme/FolxTheme';

interface IDropdownNavProps {
	label: string;
	open: boolean;
	children?: ReactNode;
	className?: string;
}

const NavList = styled.ul`
	display: flex;
	flex-flow: column;
	gap: ${theme.spacing.lg};
	padding: ${theme.spacing.lg};
`;

const DropdownNav: FC<IDropdownNavProps> = ({ children, className, label, open }) => {
	const defaultHeight = 0;
	const [navHeight, setNavHeight] = useState(defaultHeight);
	const [navRef, { height }] = useMeasure<HTMLDivElement>();

	useEffect(() => {
		setNavHeight(height);
	}, [height]);

	const animation = useSpring({
		height: open ? navHeight : defaultHeight,
		overflow: 'hidden',
	});

	return (
		<animated.div style={animation} className={className}>
			<nav ref={navRef}>
				<NavList role="menu" aria-label={label}>
					{children}
				</NavList>
			</nav>
		</animated.div>
	);
};

export default styled(DropdownNav)``;
